<template>
  <div class="checkbox">
    <checkbox
      :label="label"
      :value="getValue"
      :checked="value && 'checked'"
      :input-value="getValue"
      :disabled="disabled"
      ref="input"
      :rules="validationRules"
      :warning="warning"
      @change="[setConfigValue($event)]"
    >
      <template
        v-if="!hideTooltip && (!!tooltip || !!helpContent)"
        #append-label
      >
        <tooltip v-if="tooltip" :text="tooltip" />
        <helpIcon v-if="helpContent" :content="helpContent" />
      </template>
    </checkbox>
  </div>
</template>

<script>
/**
 * @fileoverview Config input field for checkboxes
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import checkbox from "@/qux-common/qux22/components/molecules/checkbox";
import getValidationRules from "@/util/getValidationRules";
import tooltip from "@/components/tooltip";
import helpIcon from "@/components/help-icon";

export default {
  name: "CheckboxField",
  components: { checkbox, tooltip, helpIcon },
  props: {
    category: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    helpContent: {
      type: String,
    },
    hideTooltip: {
      type: Boolean,
    },
    id: {
      type: String,
    },
    label: {
      type: String,
    },
    parentField: {
      type: String,
    },
    rules: {
      type: Array,
    },
    tooltip: {
      type: String,
    },
    value: {
      type: [Boolean, String],
    },
    warning: {
      type: String,
    },
  },
  methods: {
    /**
     * Sets the value
     */
    setConfigValue(value) {
      this.$emit("setConfigValue", !!value);
    },
    validate() {
      return this.$refs.input.validate();
    },
  },
  computed: {
    getValue() {
      return this.value === true || this.value === "true";
    },
    validationRules() {
      return getValidationRules({
        rules: this.rules,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  display: flex;
  gap: $qvo-spacing-8;
}
</style>